<script>
import DialogAction from '@/components/profile/administrationManagement/AdministrationManagementTableAction.vue'
import {mapActions, mapGetters} from 'vuex'

export default {
  components: { DialogAction },
  data: () => ({
    organizationName: '',
    isSubOrganisation: true,
    selectedSubOrganisationId: null
  }),
  computed: {
    ...mapGetters(['selectedOrganization', 'organizationsWithAdminPermissions', 'organizations']),
    flattenedOrganizations() {
      if(this.$route.path.includes('administrationManagement')){
        return this.organizationsWithAdminPermissions.reduce((acc, val) => {
          acc.push(val)
          if (val.children) {
            acc = acc.concat(val.children)
          }
          return acc
        }, [])
      }else{
          return this.organizations.reduce((acc, val) => {
          acc.push(val)
          if (val.children) {
            acc = acc.concat(val.children)
          }
          return acc
        }, [])
      }
    },
  },
  methods: {
    ...mapActions(['createOrganization', 'renameOrganization']),
    resetOrganizationCreationFields() {
      this.organizationName = ''
      this.selectedSubOrganisationId = null
    },
    getParentOrganizationId(){
      if(this.$store.getters.selectedOrganization){
        return this.selectedSubOrganisationId ? this.selectedSubOrganisationId : this.selectedOrganization.OrganizationId
      }
    },
    createNewOrganization() {
      const organization = {
        name: this.organizationName,
        parentOrganizationId: this.getParentOrganizationId(),
        inheritPermissions: true
      }
      this.createOrganization(organization)
      .then(() => {
        this.$emit('created-organization', organization)
        this.resetOrganizationCreationFields()
      })
      .catch(() => this.$emit('error-creating-organization', organization))
    }
  }
}
</script>
<template>
  <DialogAction
    confirmation
    icon="mdi-plus"
    @confirmed="createNewOrganization"
    @canceled="resetOrganizationCreationFields">
    <template slot="confirmationContent">
      <div v-html="$t('component.profile.tabs.organizationCreationDialog.name.organization')"></div>
      <v-text-field
        v-model="organizationName"
        :label="$t('component.profile.tabs.organizationCreationDialog.organization.name.label')"
        flat
        hide-details
        prepend-inner-icon="mdi-domain"
        clearable>
      </v-text-field>
      <v-checkbox
        v-if="organizations.length > 0"
        v-model="isSubOrganisation"
        disabled
        :label="$t('component.profile.tabs.organizationCreationDialog.sub.organization.checkbox')"></v-checkbox>
      <v-autocomplete
        v-if="organizations.length > 0"
        :value="selectedOrganization.OrganizationId"
        :flat="false"
        :items="flattenedOrganizations"
        :item-text="item => item.OrganizationId + ': ' + item.OrganizationName"
        :item-value="item => item.OrganizationId"
        :label="$t('component.profile.tabs.organizationCreationDialog.select.label')"
        :no-data-text="$t('component.profile.tabs.organizationCreationDialog.no.organization.found.text')"
        hide-details
        density="compact"
        @input="(selected) => selectedSubOrganisationId = selected">
        <template #item="{ item }">
          <small>{{item.OrganizationId}}:&nbsp;</small>
          <small>{{item.OrganizationName}}</small>
        </template>
      </v-autocomplete>
    </template>
    <template slot="tooltip">
      <span>{{$t('component.profile.tabs.organizationCreationDialog.create.new.organization.tooltip')}}</span>
    </template>
  </DialogAction>
</template>
